/**
 * Whether query limits are enabled in Metrics Explorer.
 */
export const EXPLORER_LIMITS_ENABLED_STORAGE_KEY = 'CHRONOSPHERE_EXPLORER_QUERY_LIMITS_ENABLED' as const;

/**
 * Whether query limits are enabled in Dashboards.
 */
export const DASHBOARDS_LIMITS_ENABLED_STORAGE_KEY = 'CHRONOSPHERE_DASHBOARDS_QUERY_LIMITS_ENABLED' as const;

/**
 * The numeric value for max data points if limits are enabled.
 */
export const QUERY_LIMITS_MAX_DATA_POINTS_KEY = 'CHRONOSPHERE_QUERY_LIMITS_MAX_DATA_POINTS';

/**
 * The numeric value for max series if limits are enabled.
 */
export const QUERY_LIMITS_MAX_SERIES_KEY = 'CHRONOSPHERE_QUERY_LIMITS_MAX_SERIES';

/**
 * The unique ID of instant and range requests executed at the same time by the Metrics Explorer.
 */
export const EXPLORER_REQUEST_ID_KEY = 'chrono-explorer-request-id';

/**
 * Headers potentially added the query requests to tell m3 to limit the number
 * of datapoints and/or series returned. Should be set to a numeric value.
 */
export const LimitRequestHeaders = {
  DATA_POINTS: 'M3-Limit-Max-Returned-Datapoints',
  SERIES: 'M3-Limit-Max-Returned-Series',
};

/**
 * Header returned by M3 when the results of a query have been limited/truncated
 */
export const LIMIT_RESPONSE_HEADER = 'M3-Returned-Data-Limited';

/**
 * Header returned when the query has been rewritten by the query optimizer.
 */
export const OPTIMIZED_QUERY_HEADER = 'M3-Optimizer-Optimized-Query';

/**
 * The JSON-encoded data returned in the limit response header
 */
export interface LimitReturnData {
  Limited?: boolean;
  Series: number;
  TotalSeries: number;
  Datapoints: number;
}

/**
 * Warnings that start with this prefix will be tagged as related to query truncation
 * and show as notices in dashboard banner or panel header.
 */
export const QUERY_TRUNCATION_WARNING_PREFIX = 'Results truncated to';
